import React from 'react';
import { DIFFERENTIALS } from '../../data/differentials';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { useLanguage } from '../../contexts/LanguageContext';
import { renderT } from '../../i18n/renderT';

const DifferentialsList: React.FC = () => {
    useScrollReveal();
    const { t } = useLanguage();

    return (
        <section className="mf-diff" id="differentials">
            <div className="container">
                <div className="section-label reveal">{t('mf.diffLabel')}</div>
                <h2 className="mf-diff-headline reveal">
                    {renderT(t('mf.diffHeadline'))}
                </h2>
                <div className="mf-diff-grid">
                    {DIFFERENTIALS.map((d) => (
                        <div key={d.num} className="mf-diff-card reveal">
                            <div className="mf-diff-num">{d.num}</div>
                            <div className="mf-diff-title">{t(`diff.${d.num}.title` as any)}</div>
                            <div className="mf-diff-body">{t(`diff.${d.num}.body` as any)}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default DifferentialsList;
